import React from 'react';

const INPUTS_CONST = {
  validateOtp:{
    name: 'OTP',
    label: 'One-Time Validation Code',
    otpLabel: 'One-Time Validation Code'
  },
  email: {
    name: 'email',
    label: 'Email address',
    emailLabel: 'Email'
  },
  emailConfirm: {
    name: 'email-confirm',
    label: 'Confirm email address'
  },
  oldPassword: {
    name: 'oldPassword',
    label: 'Old password'
  },
  newPassword: {
    name: 'password',
    label: 'New password'
  },
  password: {
    name: 'password',
    label: 'Password'
  },
  passwordConfirmSignUp: {
    name: 'password-confirm',
    label: 'Confirm password'
  },
  passwordConfirm: {
    name: 'password-confirm',
    label: 'Confirm new password'
  },
  eligibility: {
    orgType: {
      name: 'eligibility-org-type',
      label: `Are you seeking sponsorship for an individual or an organization? (Select one)`,
      eligibilityFailureReason: `We do not sponsor individuals`,
      radios: [
        {
          id: `eligibility-org-type--individual`,
          value: '1',
          label: `Individual`
        },
        {
          id: `eligibility-org-type--organization`,
          value: '2',
          label: `Organization`
        }
      ]
    },
    orgRegionState: {
      name: 'eligibility-org-region-state',
      label: 'State of proposed event/organization'
    },
    orgRegionName: {
      name: 'eligibility-org-region-name',
      label: 'Name of proposed event/organization'
    },
    orgRegionId: {
      name: 'eligibility-org-region-id',
      label: 'Primary city/geographic location',
      eligibilityFailureReason: `We are unable to accept sponsorships requests outside of our geographic footprint`
    },
    acceptTC: {
      name: 'eligibility-org-accept-tc'
    }
  },
  orgInfo: {
    orgName: {
      name: 'OrganizationName',
      label: 'Legal name of organization'
    },
    orgAddress1: {
      name: 'OrganizationAddress1',
      label: 'Organization address 1'
    },
    orgAddress2: {
      name: 'OrganizationAddress2',
      label: 'Organization address 2 (optional)'
    },
    orgCity: {
      name: 'OrganizationCity',
      label: 'Organization city'
    },
    orgState: {
      name: 'OrganizationStateID',
      label: 'Organization state'
    },
    orgStateName: {
      name: 'OrganizationStateName'
    },
    orgZip: {
      name: 'Organizationzip',
      label: 'Organization ZIP/postal code'
    },
    orgWebsite: {
      name: 'OrganizationWebsite',
      label: 'Organization website'
    },
    orgBankContactName: {
      name: 'ClientManager',
      label: 'Current bank contact name (optional)',
      previewLabel: `Current bank contact name`
    },
    orgRelation: {
      name: 'SponsorshipReleationships',
      label: `Does your organization have a current relationship with Bank&nbsp;of&nbsp;America? (Please select all that apply)`,
      previewLabel: (
        <>
          Does your organization have a current relationship with
          Bank&nbsp;of&nbsp;America?
        </>
      ),
      checkBoxes: [
        {
          id: 'org-rel-board-membr',
          value: 'boa-board-member',
          label: 'Bank of America board member',
          mutuallyExclusiveTo: ['no-relation']
        },
        {
          id: 'org-rel-cust-client',
          value: 'customer-client',
          label: 'Customer/client relationship',
          mutuallyExclusiveTo: ['no-relation']
        },
        {
          id: 'org-rel-employee',
          value: 'boa-employee',
          label: 'Bank of America employee',
          mutuallyExclusiveTo: ['no-relation']
        },
        {
          id: 'org-rel-no-relation',
          value: 'no-relation',
          label: 'No current relationship',
          mutuallyExclusiveTo: [
            'boa-board-member',
            'customer-client',
            'boa-employee'
          ]
        }
      ]
    },
    // orgBoardMembers: {
    //   name: 'MajorityOwners',
    //   label: 'Majority owners or board members (separate names with a comma)',
    //   previewLabel: `Majority owners or board members`
    // },
    orgIs501c3: {
      name: 'is_501c3',
      label: 'Is your company a 501(c)(3) organization?',
      radios: [
        { id: 'is_501c3-true', value: 73775, label: 'Yes' },
        { id: 'is_501c3-false', value: 73776, label: 'No' }
      ]
    },
    orgIs501c4: {
      name: 'IsCompany501',
      label: 'Is your company a 501(c)(4) or 501(c)(6) organization?',
      radios: [
        { id: 'IsCompany501-true', value: 159903, label: 'Yes' },
        { id: 'IsCompany501-false', value: 159904, label: 'No' }
      ]
    }
  },
  contactInfo: {
    salutation: {
      name: 'SalutationID',
      label: 'Salutation (optional)'
    },
    salutationTitle: {
      name: 'SalutationTitle'
    },
    firstName: {
      name: 'FirstName',
      label: 'First name<br/><br/>',
      previewLabel: 'First name'
    },
    lastName: {
      name: 'LastName',
      label: 'Last name<br/><br/>',
      previewLabel: 'Last name'
    },
    middleInitial: {
      name: 'MiddleInitial',
      label: 'Middle initial (optional)',
      previewLabel: `Middle initial`
    },
    jobTitle: {
      name: 'JobTitle',
      label: 'Job title'
    },
    phone: {
      name: 'PhoneNumber',
      label: 'Phone XXX-XXX-XXXX (U.S. number only)',
      previewLabel: `Phone`
    }
  },
  event: {
    eventName: {
      name: 'EventName',
      label: 'Official name of sponsorship or event'
    },
    eventCategory: {
      name: 'CategoryID',
      label: 'Choose the category that best describes your opportunity'
    },
    eventCategoryName: {
      name: 'CategoryName'
    },
    eventAmount: {
      name: 'AmountRequested',
      label: 'Sponsorship amount requested (in $ USD) <br /><br />',
      previewLabel: `Sponsorship amount requested`
    },
    eventAge: {
      name: 'YearsExistence',
      label:
        'How long has this event/sponsorship been held?<br/> (For a new event, enter “0”)',
      previewLabel: `Years in existence`
    },
    eventAttendance: {
      name: 'Attendance',
      label:
        'Estimated attendance or viewers (Please do not include exhibitor, staff, etc.)',
      previewLabel: `Estimated attendance or viewers`
    },
    eventConstituents: {
      name: 'LowModerateIncomeBenefit',
      label:
        'Does this sponsorship benefit any low-to-moderate income constituents?'
    }
  },
  sponsors: {
    sponsors: {
      name: 'Sponsors'
    },
    sponsorName: {
      name: 'Name',
      label: 'Sponsor name'
    },
    sponsorCategory: {
      name: 'CategoryId',
      label: 'Category'
    },
    sponsorCategoryName: {
      name: 'CategoryName'
    },
    sponsorSinceYear: {
      name: 'SponsorSince',
      label: 'Sponsor since year',
      previewLabel: `Sponsor since year`
    },
    sponsorshipPackages: {
      name: `sponsorship-packages`,
      addButtonLabel: `Add File`,
      typeID: 1,
      maxFile: 3
    },
    sponsorshipLogos: {
      name: `sponsorship-logos`,
      label: `Logo`,
      addButtonLabel: `Add Logo`,
      typeID: 2,
      maxFile: 1
    },
    sponsorshipImages: {
      name: `sponsorship-images`,
      label: `Images`,
      addButtonLabel: `Add Image`,
      typeID: 3,
      maxFile: 3
    },
    filename: {
      name: `Name`
    }
  },
  locationsAndDates: {
    locationsAndDates: {
      name: 'SponsorshipEvents'
    },
    locationAndDateTitle: {
      name: 'Title',
      label: 'Event title'
    },
    locationAndDateFrequency: {
      name: 'Frequency',
      label: 'Opportunity frequency'
    },
    locationAndDateFrequencyTitle: {
      name: 'FrequencyTitle',
      label: 'Opportunity frequency'
    },
    locationAndDateCity: {
      name: 'City',
      label: 'City'
    },
    locationAndDateState: {
      name: 'StateID',
      label: 'State'
    },
    locationAndDateStateName: {
      name: 'StateName'
    },
    locationAndDateStart: {
      name: 'DateFrom',
      label: 'Start date'
    },
    locationAndDateEnd: {
      name: 'DateTo',
      label: 'End date'
    }
  },
  opportunityDescription: {
    description: {
      name: 'Explanation',
      label:
        'Please explain why your sponsorship opportunity should be considered. (1,000 character maximum)',
      previewLabel: `Opportunity Description`
    }
  },
  sponsorshipBenefits: {
    description: {
      name: 'SponsorshipBenefits',
      label:
        'Please describe the benefits offered to sponsors. Examples include event tickets, branding/advertisement, speaking opportunities, etc. (1,000 character maximum)',
      previewLabel: `Sponsorship Benefits`
    }
  },
  techHelp: {
    issueType: {
      name: 'tech-help-issue-type',
      label: 'Issue/request type'
    },
    issueDescription: {
      name: 'tech-help-issue-description',
      label: 'Issue/request description'
    }
  },
  emulate: {
    name: 'email',
    label: 'Emulate User'
  }
};

export default INPUTS_CONST;
